import { useSelector } from 'react-redux';
import { getCurrentUserProfileState } from 'data/current-user-profile';
export const useUser = ()=>{
    const context = useSelector(getCurrentUserProfileState);
    if (!context.data) {
        throw new Error('User Profile is not loaded');
    }
    return context.data;
};
export const useUserSafe = ()=>{
    const context = useSelector(getCurrentUserProfileState);
    return context.data;
};
// To be used only when anonymous user check is needed
export const useIsUserAnonymousSafe = ()=>{
    const context = useSelector(getCurrentUserProfileState);
    if (!context.data) {
        return true;
    }
    return false;
};
